import { motion } from 'framer-motion';
import type { CSSProperties, ReactNode } from 'react';
import { useFastLane } from '../store/index';
import { forwardRef } from 'react';

function ColorRushTransition({children, farRight, style, ...props}: {children?: ReactNode, farRight: number, style?: CSSProperties}, ref: any) {
  const colorRush = useFastLane(f => f.colorRush);
  const swipeOffDirection = colorRush?.swipeOffDirection ?? 'left';
  
  return (
    <motion.div
      ref={ref}
      style={{
        ...style,
      }}
      initial={{
        clipPath: `inset(0px ${farRight}px 0px 0px)`,
      }}
      animate={{
        clipPath: `inset(0px 0px 0px 0px)`,
      }}
      exit={{
        clipPath: swipeOffDirection === 'left' ? `inset(0px ${farRight}px 0px 0px)` : `inset(0px 0px 0px ${farRight}px)`,
      }}
      transition={{
        duration: 1,
      }}
      {...props}
    >
      {children}
    </motion.div>
  )
}

export default motion(forwardRef(ColorRushTransition));
